<template>
    <div mdi-view-dashboard>
      <h2 class="primary--text ma-6">Aufgaben</h2>
  


      <v-btn class="fab-button"
      icon 
      @click="openAddPopup" 
      style="position: absolute; top: 20px; right: 20px;">
      
      <v-icon>mdi-plus</v-icon>
    </v-btn>





    <v-dialog v-model="dialogAdd" max-width="400" hide-overlay>
      
      <v-card :style="{ boxShadow: 'none', background: 'white' }">
        <v-card-title class="headline">Aufgabe hinzufügen für</v-card-title>
        <v-card-text>
          <!-- Gruppenmodule Dropdown nur anzeigen, wenn kein Einzelmodul ausgewählt wurde -->
          <v-select
            v-if="!selectedSingleModule"
            v-model="selectedGroupModule"
            :items="groupModules"
            item-value="id_zuordnung_final_gmv_sar"
            item-text="GM"
            label="Gruppenmodul"
            return-object
          ></v-select>
    
          <!-- Einzelmodule Dropdown nur anzeigen, wenn kein Gruppenmodul ausgewählt wurde -->
         <!-- Dieser Block wird vorerst ausgeblendet:
<v-select
  v-if="!selectedGroupModule"
  v-model="selectedSingleModule"
  :items="singleModules"
  item-value="id_zuordnung_final_emv_sar"
  item-text="EM"
  label="Einzelmodul"
  return-object
></v-select>
-->

          
          <v-text-field
           v-if="selectedGroupModule || selectedSingleModule"
          label="Arbeitstitel" 
          v-model="arbeitstitel"
          hide-details="auto"
          class="pa-5  pl-0  css-text-rot "
          style="width:250px !important;"
        ></v-text-field>


          
              <v-textarea
              v-if="selectedGroupModule || selectedSingleModule"
              v-model="beschreibungNeuerPunkt"
              label="Beschreibung"
              auto-grow
              outlined
              dense
            ></v-textarea>


            <v-checkbox
            v-if="selectedGroupModule || selectedSingleModule"
            v-model="internNeu"
            label="stationsintern"
            :true-value="true"
            :false-value="false"
            hide-details
          ></v-checkbox>
          

<!-- Hinweis-Bereich, der immer sichtbar ist -->
<div class="hinweis" v-if="selectedGroupModule || selectedSingleModule">
  <p>
    Hinweis: Bitte prüfe, ob die Aufgabe intern sein soll.
  </p>
</div>



        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addModules">Hinzufügen</v-btn>
          <v-btn text @click="breche_ab">Abbrechen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    




      <!-- Sticky Header: SAR-Auswahl und Filterfeld -->
      <div class="kopfbereich-sticky###">
        <v-row justify="left" class="ma-0 pa-0">
          <v-col cols="12" md="6">
            <v-select
              class="mb-2 ml-0 pa-0 black--text"
              outlined
              :items="schiffsliste_auswahl"
              v-model="selected_id_sar"
              item-text="schiff_name"
              item-value="id_sar"
              label="wähle Hauptmodul"
              @change="update_id_sar_global(); zeige_aufgaben()"
            />
          </v-col>
          <v-col cols="7" md="7" class="mb-5 pa-2 mt-n8 ">
            <v-text-field
              v-model="search"
              label="Filtern ..."
              append-icon="mdi-magnify"
              hide-details
              outlined
              dense
              @focus="search = ''"
            />
          </v-col>
        </v-row>
      </div>
  
      <!-- Checkboxen für Statusfilter -->
      <v-row justify="left" class="ma-2 pa-0 mt-n12">
        <v-col cols="auto">
          <v-checkbox
            color="#9b9e9e"
            v-model="statusselected"
            label="offen"
            value="offen"
            @change="zeige_aufgaben()"
          />
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            color="#9b9e9e"
            v-model="statusselected"
            label="in Arbeit"
            value="in Arbeit"
            @change="zeige_aufgaben()"
          />
        </v-col>
        <v-col cols="auto">
            <v-checkbox
            color="#81c9c7"
            v-model="internselected"
            label="nur intern"
            :true-value="1"
            :false-value="0"
            @change="zeige_aufgaben()"
          />
                  </v-col>
      </v-row>
  
      <!-- Aufgaben werden als v-card angezeigt -->
      <v-row class="mt-n4">
        <v-col
          v-for="aufgabe in filteredAufgaben"
          :key="aufgabe.id_aufgabe"
          cols="12"
          sm="6"
          md="4"
        >
    <v-card class="ml-2 mr-2">
      <v-card-title>
        <div class="d-flex align-center w-100">
          <div class="subtitle-1 primary--text">{{ aufgabe.Gruppenmodul_Bezeichnung }}</div>
        </div>
      </v-card-title>

      <!-- Inhalt der Karte -->
      <v-card-text>
        <!-- Hier können weitere Inhalte stehen -->

        <div>
          <div class="subtitle-1 mt-n4">{{ aufgabe.arbeitstitel }}</div>
        </div>


        <div>
          <!-- <strong>Beschreibung:</strong> -->
          <div class="mt-3">{{ aufgabe.beschreibung }}</div>
        </div>
        

        <!-- weitere Felder nach Bedarf -->
      </v-card-text>








      <!-- Aktionen: Status neben Popup-Symbol, Popup weiter rechts eingerückt -->
      <v-card-actions>
        <v-row no-gutters align="center" class="w-100">
          <!-- Spalte für Popup-Aktivator, weiter links -->
          <v-col cols="auto" class="pl-8">
            <Popup_aufgabe
              :ref="'popup_' + aufgabe.id_aufgabe"
              @emit_closepopup="popupgeschlossen"
              title="Aufgaben / ToDo anzeigen"
              :anzahl_aufgaben_dateien="aufgabe.anzahl_dateien"
              :current_user_id="current_user_id"
              herkunft="von_aufgabenliste"
              :prop_id_aufgabe="aufgabe.id_aufgabe"
              :id_sar="aufgabe.id_sar"
              :id_typ_sar="aufgabe.id_typ_sar"
              :schiff_name="aufgabe.schiff_name"
              :anzahl_aufgaben="aufgabe.anzahl_aufgaben"
              :id_gmv="aufgabe.id_gmv"
              :id_emv="0"
              :gruppen_modul_bezeichnung="aufgabe.Gruppenmodul_Bezeichnung"
              :einzel_modul_bezeichnung="0"
              :id_zuordnung_final_gmv_sar="aufgabe.id_zuordnung_final_gmv_sar"
              :id_zuordnung_final_emv_sar="0"
            />
          </v-col>
          <!-- Spalte für Status, etwas eingerückt, damit er nicht überlappt -->
          <v-col cols="auto" class="pl-12">
            <span class="subtitle-2"
                  :class="{
                    'red--text': aufgabe.aufgabe_status === 'offen',
                    'green--text': aufgabe.aufgabe_status === 'in Arbeit'
                  }">
              {{ aufgabe.aufgabe_status }}
            </span>
          </v-col>
          <!-- Füllspalte, falls du den restlichen Platz nutzen möchtest -->
          <v-col></v-col>
        </v-row>
      </v-card-actions>
      
      
      
      
    </v-card>

        </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
  import WerftlisteService from '@/services/WerftlisteService.js';

  import AufgabenService from '@/services/AufgabenService.js';
  import AuthService from '@/services/AuthService.js';
  import SchiffeService from '@/services/SchiffeService';
  import { EventBus } from '../main';
  import Popup_aufgabe from '../components/Popup_aufgabe.vue';
  
  export default {
    data() {
      return {
        // SAR-Auswahl und Filter
        schiffsliste_auswahl: [],
        selected_id_sar: null,
        search: '',
        // Status- und intern-Filter mit sicheren Default-Werten (nicht null)
        statusselected: ['offen', 'in Arbeit'],
        internselected: 0,
  
        aufgabenliste: [],
        current_user_id: '',
        ladetabelle: false,
        dialogAdd: false,
    selectedModuleType: '',  // 'group' für Gruppenmodule, 'single' für Einzelmodule
    selectedGroupModule: null,
    selectedSingleModule: null,
    groupModules: [],
    singleModules: []  ,
    beschreibungNeuerPunkt: '',
    arbeitstitel: '',
    internNeu: false, // Neue Variable für Checkbox "intern"
 
      };
    },
    computed: {
      filteredAufgaben() {
        let tasks = this.aufgabenliste;
        // Filtere Aufgaben nach ausgewählter SAR-Einheit
        if (this.selected_id_sar) {
          tasks = tasks.filter(item => item.id_sar === this.selected_id_sar);
        }
        // Zusätzlicher lokaler Filter über das Suchfeld
        if (this.search) {
          const searchLower = this.search.toLowerCase();
          tasks = tasks.filter(
            item =>
              (item.arbeitstitel &&
                item.arbeitstitel.toLowerCase().includes(searchLower)) ||
              (item.beschreibung &&
                item.beschreibung.toLowerCase().includes(searchLower)) ||
              (item.Gruppenmodul_Bezeichnung &&
                item.Gruppenmodul_Bezeichnung.toLowerCase().includes(searchLower)) ||
              (item.schiff_name &&
                item.schiff_name.toLowerCase().includes(searchLower))
          );
        }
        return tasks;
      }
    },
    methods: {


  //*************  Aufgabe hinzufügen **********************************************************************
            

            async addModules() {
            // Hier prüfen wir, ob eine SAR-Einheit und ein Gruppenmodul ausgewählt wurde.
            if (!this.selected_id_sar || !this.selectedGroupModule) {
              alert('Bitte ein Gruppenmodul und eine SAR-Einheit auswählen.');
              return;
            }

            // Hier prüfen wir, ob ein Titel eingegeben wurde.
            if (!this.arbeitstitel) {
              alert('Bitte einen Titel eintragen, da sonst nicht gespeichert wird.');
              return;
            }

            // Da nur Gruppenmodule verfügbar sind, wird isGroup immer true:
            const id_gmv = this.selectedGroupModule.id_gmv;
            // Einzelmodul-Felder werden auf 0 gesetzt:
            const id_emv = 0;
            const id_zuordnung_final_emv_sar = 0;
            const id_zuordnung_final_gmv_sar = this.selectedGroupModule.id_zuordnung_final_gmv_sar;

            const schiff = this.schiffsliste_auswahl.find(s => s.id_sar === this.selected_id_sar);
            this.id_typ_sar = schiff ? schiff.schiff_module_typ : null;

            const payload = {
              id_sar: this.selected_id_sar,
              id_typ_sar: this.id_typ_sar || '0',
              id_gmv: id_gmv,
              id_emv: id_emv,  // wird 0 übergeben
              id_zuordnung_final_emv_sar: id_zuordnung_final_emv_sar,  // wird 0 übergeben
              id_zuordnung_final_gmv_sar: id_zuordnung_final_gmv_sar,
              user_id: this.current_user_id,
              beschreibung: this.beschreibungNeuerPunkt || '',
              arbeitstitel: this.arbeitstitel || '',
              intern: this.internNeu,  // der Wert aus der Checkbox "Intern"
            };

            try {
              await AufgabenService.neue_aufgabe_einfuegen(payload);
              // Reset der Eingabefelder nach erfolgreichem Hinzufügen
              this.dialogAdd = false;
              this.selectedGroupModule = null;
              // this.selectedSingleModule nicht nötig, da Einzelmodule ausblenden
              this.beschreibungNeuerPunkt = '';
              this.arbeitstitel = '';
              this.internNeu = false;
              this.zeige_aufgaben();
            } catch (error) {
              console.error('Fehler beim Hinzufügen des Werftpunkts:', error);
            }
          },



  breche_ab () {
    this.dialogAdd = false;
    this.selectedGroupModule = null;
    this.selectedSingleModule = null;
    this.groupModules= [];
    this.singleModules= [];  
  },

      openAddPopup() {
        this.dialogAdd = true;
      this.loadGroupModules();  // Lade Gruppenmodule
      this.loadSingleModules();  // Lade Einzelmodule
      },

  // Laden der Gruppenmodule basierend auf id_sar
  async loadGroupModules() {
    try {
      const response = await WerftlisteService.zeigegruppenmodule_per_id({id_sar:this.selected_id_sar});
      this.groupModules = response.recordset;
    } catch (error) {
      console.error('Fehler beim Laden der Gruppenmodule:', error);
    }
  },

  // Laden der Einzelmodule basierend auf id_sar
  async loadSingleModules() {
    try {
      const response = await WerftlisteService.zeigeeinzelmodule_per_id({id_sar:this.selected_id_sar});
      this.singleModules = response.recordset;
    } catch (error) {
      console.error('Fehler beim Laden der Einzelmodule:', error);
    }
  },



      triggerPopup(aufgabe) {
    // Da bei v-for dynamische Refs als Array zurückgegeben werden, greifen wir auf das erste Element zu.
    const popupInstance = this.$refs['popup_' + aufgabe.id_aufgabe];
    if (popupInstance && popupInstance[0] && typeof popupInstance[0].open === 'function') {
      popupInstance[0].open();
    }
  },

      async hole_user_id() {
        try {
          const response = await AuthService.hole_user_id({});
          this.current_user_id = response;
        } catch (err) {
          console.error('Fehler beim Abrufen der User-ID:', err);
        }
      },
      popupgeschlossen() {
        this.zeige_aufgaben();
      },
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.split('-');
        return `${day}.${month}.${year}`;
      },
      async zeige_aufgaben() {
        try {
          this.ladetabelle = true;
          const credentials = {
            id_sar: this.selected_id_sar,
            statusselected: this.statusselected,
            internselected: this.internselected,
          };
       
          const response = await AufgabenService.zeigeaufgaben_mit_schiffsauswahl(credentials);
          if (typeof response.msg !== 'undefined') {
            this.$router.push('/login');
          }
          this.aufgabenliste = response.recordset;
          this.ladetabelle = false;
        } catch (error) {
          console.error('Fehler beim Laden der Aufgaben:', error);
        }
      },
      async zeige_sar_einheit_auswahl() {
        try {
          const response = await SchiffeService.zeigeschiffe();
          if (response?.msg) {
            this.$router.push('/login');
            return;
          }
          this.schiffsliste_auswahl = response.recordset;
          const gespeicherteSAR = localStorage.getItem('id_sar_ausgewaehlt_global');
          if (gespeicherteSAR) {
            this.selected_id_sar = parseInt(gespeicherteSAR);
          } else if (this.schiffsliste_auswahl.length > 0) {
            // Setze den ersten Eintrag als Standardwert, falls keiner vorhanden ist
            this.selected_id_sar = this.schiffsliste_auswahl[0].id_sar;
            localStorage.setItem('id_sar_ausgewaehlt_global', this.selected_id_sar);
            EventBus.$emit('sende_globale_id_sar', this.selected_id_sar);
          }
          //this.zeige_aufgaben();
        } catch (error) {
          console.error('Fehler beim Laden der SAR-Einheiten:', error);
        }
      },

      update_id_sar_global() {
        if (this.selected_id_sar) {
          localStorage.setItem('id_sar_ausgewaehlt_global', this.selected_id_sar);
          EventBus.$emit('sende_globale_id_sar', this.selected_id_sar);
        }
      },
      zum_login() {
        this.$router.push('/login');
      }
    },
    created() {

   
            //  wenn name_sar_ausgewaehlt_global   in localStorage   bei  Modulaufruf  nicht leer ist, dann setze Anzeige ausgewähltes Schiff (selected_name_sar) aus localStorage)
            if(typeof(localStorage.name_sar_ausgewaehlt_global) !== "undefined" && localStorage.name_sar_ausgewaehlt_global !=='' ) {
                this.selected_name_sar = localStorage.name_sar_ausgewaehlt_global
            }

            if(typeof(localStorage.id_sar_ausgewaehlt_global) !== "undefined" && localStorage.id_sar_ausgewaehlt_global !=='' ) {
                this.id_sar_ausgewaehlt_global = localStorage.id_sar_ausgewaehlt_global
                this.selected_id_sar = localStorage.id_sar_ausgewaehlt_global
            }
            
            this.hole_user_id();
            this.update_id_sar_global();
            this.zeige_sar_einheit_auswahl();
            this.zeige_aufgaben();


          EventBus.$on('sende_globale_id_sar', val => {
            this.selected_id_sar = val;
            this.id_sar_ausgewaehlt_global =  val;
            this.zeige_aufgaben();
          });

   



    },
    components: {
      Popup_aufgabe
    }
  };
  </script>
  
  <style>

.hinweis {

  font-size:12px;
  font-style: italic;
  margin-top:5px;
}




  .kopfbereich-sticky {
    position: sticky;
    top: 0;
    background: white;
    z-index: 20;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
  }
  </style>
  